<div class="container">
  <nav class="nav-links">
    @if (isLogged() && !isDesktop) {
      <mdcr-user-header [isLandingPage]="true" />
    }
    <a [routerLink]="APPLICATION_ROUTES.healthcareFacilities">Healthcare Facilities</a>
    <a [routerLink]="APPLICATION_ROUTES.clinicians">Clinicians</a>
  </nav>

  <div class="action-buttons">
    @if (!isLogged()) {
      <mdcr-button
        class="action-buttons__sign outlined"
        routerLink="/sign-in"
        [label]="'Sign In'"
      />
      <mdcr-button
        class="filled"
        routerLink="/sign-up-facility"
        [label]="'Create an Account'"
      />
    } @else {
      @if (!isDesktop) {
        <mdcr-button
          class="outlined"
          [routerLink]="getPortalRoute()"
          [label]="'Return to Portal'"
        />
        <mdcr-button
          class="filled"
          (click)="openModal()"
          [label]="'Sign Out'"
        />
      } @else {
        <mdcr-user-header [isLandingPage]="true" />
      }
    }
  </div>
</div>

<mdcr-sign-out />
